/* eslint-disable */
import React from "react";
import { Method } from '../../../controls/Method';
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Skeleton } from "@material-ui/lab";

interface MethodControlItem {
    id: number;
    name: string;
}

export const MethodControl: React.FC = React.memo(() => {
    const [items, setItems] = React.useState<MethodControlItem[]>([]);
    const [parameterValue, setParameterValue] = useParameter("@method");
    const [dictItems] = useDictionary(dictionaryService, "slides-methods");

    React.useEffect(() => {
        if (dictItems) {
            const nextItems = dictItems.map<MethodControlItem>(item => ({
                id: Number(item.id),
                name: (item.getValue("name") as any)[9] as string
            }));
            setItems(nextItems);
        }
    }, [dictItems]);

    if (!items?.length) {
        return <Skeleton variant="rect" width="168px" height="51px" />
    }
    return <Method items={items} value={parameterValue} onChange={setParameterValue} />;
});
